// material-ui
import logo_dark from 'assets/images/logo-dark.png';
import logo from 'assets/images/logo.png';
import { useAppSelector } from 'hooks';
import { Typography } from "@mui/material";

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const Logo = ({ imageSize = 50, visibleTitle = true }) => {
    const customization = useAppSelector(state => state.customization);
    let src;
    switch (customization.theme) {
        case 'light':
            src = logo;
            break;
        case 'dark':
            src = logo_dark;
            break;
        default:
            src = logo;
    }

    return (
        <>
            <img src={src} alt="Gardener" height={imageSize}/>
            { visibleTitle && (
                <Typography sx={{marginLeft: "10px", color: "#00C473"}} variant="h3">GARDENER</Typography>
            )}
        </>
    );
};

export default Logo;
